export default __webpack_public_path__ + "static/media/SEC3010.34I-38754_-22634_0.d20f944e.jpg";